import { render, staticRenderFns } from "./ProductCategoryDetail.vue?vue&type=template&id=e54f6704&"
import script from "./ProductCategoryDetail.vue?vue&type=script&lang=js&"
export * from "./ProductCategoryDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports